import { SearchFilter } from '~/types/DashboardV2';

import { camelizeFieldId } from './NodeEnricher/flattenSearchSelectedItemValues';
import { EnrichedGroupNode } from './NodeEnricher/NodeEnricher';
import { TreeBrowserNode } from './TreeBrowser/types';

export const convertSearchFieldToColumn = (field: SearchFilter) => {
  const type = /date/i.test(field.type) ? 'datetime' : 'text';

  return {
    key: field.id,
    title: field.label,
    cellType: type,
    disableSortBy: true,
    mapCellProps: (node: TreeBrowserNode<EnrichedGroupNode>) => {
      const enrichedKey = camelizeFieldId(field.id);
      const value = node.enrichedFields?.[enrichedKey];
      return {
        [type]: node.meta.isLoadMoreNode ? ' ' : value || '',
      };
    },
  };
};
